import React from 'react';

const NotFound: React.FC = () => {
    return (
        <div className="min-h-screen bg-colormainbrown flex items-center justify-center px-4">
            <div className="text-center">
                <h1 className="text-8xl font-bold text-colorpink mb-4">404</h1>
                <p className="text-xl text-white mb-8">Səhifə  mövcud deyil.</p>
                <button
                    onClick={() => window.history.back()}
                    className="inline-block px-6 py-3 bg-gray-500 text-white rounded hover:bg-gray-700 transition-colors"
                >
                    Geri
                </button>
            </div>
        </div>
    );
};

export default NotFound;